import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTab } from "../../../contexts/tab";
import { basePath } from "../../config";
import { toast } from "react-toastify";
import { useAuth } from "../../../contexts/auth";
import classNames from "classnames";

export default function DeleteCoreModal({ setCoreToDelete, coreToDelete }) {
  const isOpen = !!coreToDelete;
  const [{ tabData }, { setTabData }] = useTab();
  const [{ activeUser }] = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  function closeModal() {
    setCoreToDelete(null);
  }

  async function submitForm() {
    setIsSubmitting(true);
    const current_page = tabData?.current_page;

    // TODO:: add form validation
    try {
      const res = await fetch(basePath + "deleteCore?cores=" + current_page, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${activeUser?.remember_token}`,
        },
        body: JSON.stringify(coreToDelete),
      });

      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        return 0;
      }

      if (data.status) {
        console.log(JSON.parse(data.data));
        setTabData({ ...JSON.parse(data.data), links: tabData.links });
        setCoreToDelete(null);
        toast.success(data.message);
      } else {
        toast.error("error: " + data.message);
      }
    } catch (error) {
      toast.error("error: " + error);
      console.error("DisableEnableLabel:: api calling fail =>", error);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  Delete Core
                </Dialog.Title>

                <div className="mt-3 py-10 border-t border-b">
                  <p>
                    Are you sure want Delete this Core{" "}
                    <span className="font-bold">{coreToDelete?.core}</span>
                  </p>
                </div>

                <div className="mt-4 flex justify-end gap-3">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={submitForm}
                    disabled={isSubmitting}
                    className={classNames(
                      "inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2",
                      isSubmitting && "disabled:bg-slate-300"
                    )}
                  >
                    {" "}
                    Delete Core
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
